import React from "react";

import {

    Card,
    Space,
    Tag,
    Typography

} from "antd";

import {

    CarOutlined

} from "@ant-design/icons";

const { Title, Text } = Typography;

const DeliveryNotificationCard = ({

                                      notification

                                  }) => (

    <Card

        style={{

            marginBottom:15,

            borderRadius:12

        }}

    >

        <Space direction="vertical">

            <Title level={5}>

                <CarOutlined />

                {" "}

                Livraison

            </Title>

            <Text>

                {notification.deliveryStatus}

            </Text>

            <Tag color="processing">

                {notification.status}

            </Tag>

        </Space>

    </Card>

);

export default DeliveryNotificationCard;